package com.fireavert.user.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class UserIdByInviteTokenResponse(val userId: Int)
